//
// DataRendererModel.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./RendererModel";
import "../data/DataProvider";
import "../data/RoleMetadata";

var DataRendererModel = createModule("gtl::DataRendererModel", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel","gtl::RendererModel"], EventDispatcher, [
    ,
    {
        dataProvider: 1,
    },
    ,
    ,
    {
        getRoleMetadata: [1],
        getAllDataProviders: [[1]],
    },
    ,
    ,
]);
export default DataRendererModel;
